<template>
  <div class="white--text" v-if="componentSelected" style="height:100%">
    <v-tabs dark dense height="30px" :mobile-break-point="-1" grow :show-arrows="true">
      <v-tab>Format</v-tab>
      <v-tab>Background</v-tab>
      <v-tab><v-icon>mdi-transition</v-icon></v-tab>

      <v-tab-item dark style="background-color:rgba(0, 0, 0, 0.8)">
        <v-card flat dark tile style="background:none">
          <v-card-text>
            <v-btn @click="sendForward">
              <v-icon>mdi-arrange-bring-forward</v-icon>
            </v-btn>
            <v-btn @click="sendBackward">
              <v-icon>mdi-arrange-send-backward</v-icon>
            </v-btn>
            <v-divider></v-divider>


            <template v-if="component.type==='Image'">
                <ImageUpload v-if="!component.src" v-model="component.src" />
    <v-btn dark @click="component.src = ''" v-else>clear  image</v-btn>
<v-divider></v-divider>

        <v-overflow-btn
        v-model="component.imagePosition"
          class="my-2"
          :items="[
          {
            value: 'contain',
            text: 'Contain'
          },
          {
            value: 'cover',
            text: 'Cover'
          },
          {
            value: 'stretch',
            text: 'Stretch'
          }
          ]"
          label="Image Position"
        ></v-overflow-btn>
            </template>

                          <v-divider></v-divider>
              <h4>Border Radius {{component.borderRadius}}%</h4>
              <v-slider
                color="orange"
                min="0"
                max="100"
                v-model="component.borderRadius"
                thumb-label="true"
              ></v-slider>


            <template v-if="component.type==='Text'">
              <v-divider></v-divider>
              <FontLoader v-model="component.mainFont"></FontLoader>
              <v-divider></v-divider>

              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-icon large>mdi-palette</v-icon>
                  <v-btn
                    :style="{
                backgroundColor: component.foreGroundColor && component.foreGroundColor.hexa ? component.foreGroundColor.hexa : ''
                }"
                    label="Foreground Color"
                    persistent-hint
                    v-on="on"
                    dark
                  ></v-btn>
                </template>
                <v-color-picker v-model="component.foreGroundColor" no-title></v-color-picker>
              </v-menu>
              <v-divider></v-divider>
              <!--v-btn text @click="component.height = null">Auto Height</v-btn-->
              Font Size
              <h4>{{component.mainFontSize}}px</h4>
              <v-slider
                color="orange"
                min="10"
                max="500"
                v-model="component.mainFontSize"
                thumb-label="true"
              ></v-slider>


              <!--v-text-field
              v-model="component.mainFontSize"
              type="number"
              default="12"
              label="Font-Size"
              /-->

              <v-btn
                text
                @click="()=>component.align='left'"
                :class="{ 'is-active': component.align==='left'}"
              >
                <v-icon>mdi-format-align-left</v-icon>
              </v-btn>
              <v-btn
                text
                @click="()=>component.align='center'"
                :class="{ 'is-active': component.align==='center'}"
              >
                <v-icon>mdi-format-align-center</v-icon>
              </v-btn>
              <v-btn
                text
                @click="()=>component.align='right'"
                :class="{ 'is-active': component.align==='right'}"
              >
                <v-icon>mdi-format-align-right</v-icon>
              </v-btn>
              <v-divider></v-divider>
              <v-btn-toggle v-model="component.valign">
                <v-btn value="top">
                  <v-icon>mdi-format-vertical-align-top</v-icon>
                </v-btn>
                <v-btn value="center">
                  <v-icon>mdi-format-vertical-align-center</v-icon>
                </v-btn>

                <v-btn value="bottom">
                  <v-icon>mdi-format-vertical-align-bottom</v-icon>
                </v-btn>
              </v-btn-toggle>
              <v-divider></v-divider>
              <editor-menu-bar
                v-if="inlineEditor"
                :editor="inlineEditor"
                v-slot="{ commands, isActive }"
              >
                <div class="editor-bar">
                  <v-btn text @click="commands.bold" :class="{ 'is-active': isActive.bold() }">
                    <v-icon>mdi-format-bold</v-icon>
                  </v-btn>
                  <v-btn text @click="commands.italic" :class="{ 'is-active': isActive.italic() }">
                    <v-icon>mdi-format-italic</v-icon>
                  </v-btn>
                  <v-btn
                    text
                    @click="commands.underline"
                    :class="{ 'is-active': isActive.underline() }"
                  >
                    <v-icon>mdi-format-underline</v-icon>
                  </v-btn>
                  <v-btn
                    text
                    @click="commands.ordered_list"
                    :class="{ 'is-active': isActive.ordered_list() }"
                  >
                    <v-icon>mdi-format-list-bulleted</v-icon>
                  </v-btn>
                  <v-btn
                    text
                    @click="commands.list_item"
                    :class="{ 'is-active': isActive.list_item() }"
                  >
                    <v-icon>mdi-format-list</v-icon>
                  </v-btn>
                </div>
              </editor-menu-bar>
            </template>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item dark style="background-color:rgba(0, 0, 0, 0.8)">
        <v-card flat dark tile style="background:none">
          <v-card-text>
            <v-color-picker
              mode="hexa"
              dark
              flat
              v-model="component.backgroundColor.hexa"
              swatches-max-height="200px"
              class="ma-2"
              show-swatches
            ></v-color-picker>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item dark style="background-color:rgba(0, 0, 0, 0.8)">



                <v-overflow-btn

        v-model="component.enterTransition"
          class="my-2"
          :items="[
          'bounce',
          'flash',
          'pulse',
          'rubberBand',
          'shake',
          'headShake',
          'swing',
          'tada',
          'wobble',
          'jello',
          'bounceIn',
          'bounceInDown',
          'bounceInLeft',
          'bounceInRight',
          'bounceInUp',
          'fadeIn',
          'fadeInDown',
          'fadeInDownBig',
          'fadeInLeft',
          'fadeInLeftBig',
          'fadeInRight',
          'fadeInRightBig',
          'fadeInUp',
          'fadeInUpBig',
          'flipInX',
          'flipInY',
          'lightSpeedIn',
          'rotateIn',
          'rotateInDownLeft',
          'rotateInDownRight',
          'rotateInUpLeft',
          'rotateInUpRight',
          'jackInTheBox',
          'rollIn',
          'zoomIn',
          'zoomInDown',
          'zoomInLeft',
          'zoomInRight',
          'zoomInUp',
          'slideInDown',
          'slideInLeft',
          'slideInRight',
          'slideInUp',
          'heartBeat'
          ]"
          label="Enter Transition"
        ></v-overflow-btn>
      </v-tab-item>
    </v-tabs>
  </div>
  <div  v-else class="white--text">
    <template v-if="slide"> 
 <h4>Background Image</h4>
    <ImageUpload v-if="!slide.backgroundImage" v-model="slide.backgroundImage" />
    <v-btn dark @click="slide.backgroundImage = ''" v-else>clear background image</v-btn>
    </template>
  </div>
</template>
<style scoped lang="scss">
.editor-bar {
  .v-btn {
    &.is-active {
      background-color: rgba(255, 179, 38, 0.1);
    }
  }
}
</style>
<script>
import { mapState, mapActions } from "vuex";
import { Editor, EditorContent } from "tiptap";
import ImageUpload from "@/components/utils/ImageUpload";
import FontLoader from "@/components/event/slides/FontLoader";
import { EditorMenuBar } from "tiptap";
export default {
  components: {
    FontLoader,
    EditorMenuBar,
    ImageUpload
  },
  data() {
    return {
      menu1: false
    };
  },
  watch: {},
  computed: {
    slide() {
      const slideid = this.$route.params.slideid;
      return this.$store.state.slides.data[slideid].slides.find(
        item => item.uuid === this.$route.params.slide
      );
    },
    component() {
      return this.slide.components.find(
        item => item.uuid === this.componentSelected
      );
    },
    componentSelected() {
      return this.$store.state.editor.selectedComponent;
    },
    inlineEditor() {
      return this.$store.state.editor.inlineEditor;
    }
  },
  methods: {
    ...mapActions("editor", ["selectComponent"]),
    doSomething(state, vuwe) {
      this.component.text = state.getHTML();
    },

    sendForward() {
      this.sendBackward(false);
    },
    sendBackward(backward = true) {
      let components = this.slide.components;
      let index = components.findIndex(
        item => item.uuid === this.componentSelected
      );
      let templist = components.filter(
        item => item.uuid !== this.componentSelected
      );
      let newposition = backward ? index - 1 : index + 1;
      let newarray = [
        ...templist.slice(0, newposition),
        this.component,
        ...templist.slice(newposition, components.length)
      ];

      this.slide.components = newarray;
    }
  }
};
</script>